/*!
  =========================================================
  * Vue Paper Dashboard - v2.0.0
  =========================================================
  * Product Page: http://www.creative-tim.com/product/paper-dashboard
  * Copyright 2019 Creative Tim (http://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from './store/index';

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

/* add yarn import */
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from "./config.js"
import VueKeycloak from '@dsb-norge/vue-keycloak-js'
import moment from 'moment'

import vueXstore from '@/store/index';
import VueClipboard from 'vue-clipboard2'

import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);

// ref. https://www.npmjs.com/package/vue-html2canvas
import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);

Vue.use(PaperDashboard);
Vue.prototype.moment = moment

// facebook page
import VueFacebookPage from 'vue-facebook-page'
Vue.use(VueFacebookPage, 279855888709461/** Add your facebook appId here */)

// gaTag page
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-179956144-1',
  router,
})

// text-editor
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
// Vue.use(VueQuillEditor, /* { default global options } */)
// Vue.prototype.$liff = Window.liff

// tag input
import InputTag from 'vue-input-tag'
Vue.component('input-tag', InputTag)

// Configure axios
axios.defaults.baseURL = config.apiUrl
Vue.use(VueAxios, axios)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

/* eslint-disable no-new */
/*
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
*/

/*  keycloak import sso login to page async*/
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // console.log(to.path)
    if(!['/faq','/addcard','/stdmail'].includes(`${to.path}`)){
      window.location.href = `https://newmy.muic.io/${to.path === '/directory' ? 'directory' : 'calendar'}`
    }else{
      const res = await whoami()
      if (router.app.$keycloak.authenticated) {
        // console.log(router.app.$keycloak)
        if (res) {
          vueXstore.dispatch('setRoleUser',
            {
              username: res.username,
              roles: res.roles,
              permissions: res.permissions,
              codeId: res.usercode
            }
          )
          next()
        }else{
          router.push("/notfound").catch(err => {})
        }
      } else {
        window.location.href = router.app.$keycloak.createLoginUrl()
      }
    }
  } else {
    next()
  }
})

const whoami = async () => {
  try {
    const res = await Vue.axios.get('/whoami/')
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }
  catch (error) {
    return false;
  }   
}

function tokenInterceptor () {
  axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  }, error => {
    return Promise.reject(error)
  })
}

Vue.use(VueKeycloak,{
  init: {
    onLoad: 'check-sso'
  },
  config: {
    url: 'https://sso.muic.io/auth',
    clientId: 'portal-student',
    realm: 'IC'
  },
  onReady: (Keycloak) => {
    tokenInterceptor()
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App),
    })
  }
})